import { VIDEO_CAMPAIGN_SUFFIX } from '../../../../../config/reportIdSuffixes';

export const MONTH_VIDEO_REPORT_ID = `month${VIDEO_CAMPAIGN_SUFFIX}`;
